/**
 * Calculate reading time for blog post content
 * @param {string} content - HTML content of the blog post
 * @returns {number} Reading time in minutes
 */
export const calculateReadingTime = (content) => {
  if (!content) return 1;
  
  // Remove HTML tags
  const text = content.replace(/<[^>]*>/g, '');
  
  // Count words (split by whitespace)
  const words = text.trim().split(/\s+/).length;
  
  // Average reading speed: 200-250 words per minute
  // Using 200 for a conservative estimate
  const readingTime = Math.ceil(words / 200);
  
  // Minimum 1 minute
  return readingTime < 1 ? 1 : readingTime;
};


